import { TokenGroup } from '@amzn/awsui-components-react-v3';
import * as React from 'react';

export const PrimaryKeys = ({ keys }:{keys: string[]}) => (
  <TokenGroup items={keys.map((key) => ({ label: key, disabled: true }))} />
);
